import React from 'react'
import Service from './Service'
import '../../scss/components/Services/Services.scss'
import MainHeading from '../utils/MainHeading'
import classic1 from '../../assets/rooms/classic/IMG_4451.jpg';
import classic2 from '../../assets/rooms/classic/IMG_4452.JPG';
import classic3 from '../../assets/rooms/classic/IMG_4458.JPG';
import vip1 from '../../assets/rooms/vip/IMG_4481.JPG';
import vip2 from '../../assets/rooms/vip/IMG_4482.JPG';
import vipplus1 from '../../assets/rooms/vip+/IMG_9918.jpg';
import vipplus2 from '../../assets/rooms/vip+/IMG_9919.jpg';
import vipplus3 from '../../assets/rooms/vip+/IMG_9921.jpg';

const rooms = [
  {
    name: 'Toot توت',
    videoUrl: 'https://www.youtube.com/embed/Rs1SkSGUiaU',
    description: 'The "Aquarelle Tout" chalet is named after its distinctive berry (tout) color theme. It features a fully equipped kitchenette, direct access to a private pool and outdoor seating, and comfortably sleeps 4—perfect blend of comfort, privacy, and style.',
    thumbnail: classic1
  },
  {
    name: 'Soboh صبح',
    videoUrl: 'https://www.youtube.com/embed/yDAkh97khAg',
    description: 'Wake up to the sunrise in this bright, welcoming space.',
    thumbnail: classic2
  },
  {
    name: 'Joz جوز',
    videoUrl: 'https://www.youtube.com/embed/jcE2o8g4Xng',
    description: 'A tranquil room named after the walnut tree, offering peace and comfort.',
    thumbnail: classic3
  },
  {
    name: 'Zaitoun زيتون',
    videoUrl: 'https://www.youtube.com/embed/OMTthspsz-8',
    description: 'Olive-inspired decor and a calming atmosphere await you.',
    thumbnail: vip1
  },
  {
    name: 'Sama سما',
    videoUrl: 'https://www.youtube.com/embed/OqGyobLKs-o',
    description: 'Enjoy sky views and a serene ambiance in this unique room.',
    thumbnail: vip2
  },
  {
    name: 'Laimon ليمون',
    videoUrl: 'https://www.youtube.com/embed/KulH-l-aX1k',
    description: 'A zesty, fresh room inspired by the lemon tree.',
    thumbnail: vipplus1
  },
  {
    name: '7amed حامض',
    videoUrl: 'https://www.youtube.com/embed/vPHoZrwhKFY',
    description: 'A tangy, lively space for a memorable stay.',
    thumbnail: vipplus2
  },
  {
    name: 'Joury جوري',
    videoUrl: 'https://www.youtube.com/embed/nAcsw9PzNts',
    description: 'A floral, romantic room inspired by the Damask rose.',
    thumbnail: vipplus3
  },
]

const Services = () => {
  return (
    <>
      <div className="services-heading">
        <MainHeading title="Aquarelle Rooms" id="roomspage" />
        <p className="rooms-description">
          Experience comfort and luxury in our thoughtfully designed rooms at Aquarelle Resort.
          Each room is uniquely named after local fruits and trees, offering stunning valley views
          and modern amenities. From cozy classic accommodations to premium suites, our rooms
          provide the perfect retreat for your stay in South Lebanon.
        </p>
      </div>
      <div className="services-container">
        {rooms.map((room, idx) => (
          <Service key={idx} name={room.name} videoUrl={room.videoUrl} description={room.description} thumbnail={room.thumbnail} />
        ))}
      </div>
    </>
  )
}

export default Services